// removed by extract-text-webpack-plugin
module.exports = {"plan-title":"plan-title__3_6zY","plan-subtitle":"plan-subtitle__1INPi","plan-title-sm":"plan-title-sm__6CZ-1","tip-item":"tip-item__AJ5Sn","tip-icon":"tip-icon__1SEL9"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/planTitle.scss
// module id = 507
// module chunks = 68